import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { TextDto } from '../dto/TextDto';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApiVideoLection } from './getApiVideoLection';

export const apiSaveVideoLection = async (name: string, dto: TextDto) => {
  const params: IApiParams = {
    url: `/saveVideoLection.php?name=${name}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApiVideoLection(params, 'POST', dto);
};
